import React, { useEffect, useState } from 'react'
import { notificationListing, readNotification } from '../../api/apiHandler'
import { Loading } from '../../components/loading/loading';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import '../../i18';
import ReactPaginate from "react-paginate";

const Notification = () => {
    const { t } = useTranslation();

    const [isLoading, setIsLoading] = useState(true);
    const [notification, setNotification] = useState([]);
    const [pageToken, setPageToken] = useState(1);
    const [totalPage, setTotalPage] = useState('');

    useEffect(() => {
        setIsLoading(true);
        const fetchData = async () => {
            await getNotification();
            markAsReadNotification();
        };
        setIsLoading(false)
        fetchData();
    }, [pageToken]);

    const getNotification = async () => {
        const response = await notificationListing({
            limit: 10,
            page: pageToken
        });
        if (response?.code == 200) {
            setNotification(response?.data?.data);
            setTotalPage(response.data.paging);
        }
    }

    const markAsReadNotification = async () => {
        const response = await readNotification();
    }

    function formatUTCToCustom(utcDateString) {
        return moment(utcDateString).format('ddd, D MMM [at] HH:mm');
    }

    const handlePageClick = (e) => {
        setPageToken(e.selected + 1)
    }

    if (isLoading) {
        return (
            <Loading />
        )
    }
    return (
        <>
            <div className="course-single-area pd-top-120 pd-bottom-90 bgBrown">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="PageTitleBox">
                                <h2 className="PageTitleHeading">{t('notificationHeading')}</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-12 col-sm-12 col-12">
                            <ul className="NotificationTabBoxUl">
                                {notification.length > 0 && notification.map((notification, i) => (
                                    <li className="NotificationTabBoxLi" key={i}>
                                        <div className="NotificationTabBoxLiLeft">
                                            <img
                                                src={process.env.PUBLIC_URL + "/assets/img/icon/notificationbell.svg"}
                                                alt="NotificationBellIcon"
                                                className="NotificationBellIcon"
                                            />
                                        </div>
                                        <div className="NotificationTabBoxLiright">
                                            <p className="NotificationRightText fw-bold">
                                                {notification?.title}
                                            </p>
                                            <p className="NotificationRightText">
                                                {notification?.message}
                                            </p>
                                            <span className="NotificationDate">{formatUTCToCustom(notification?.createdAt)}</span>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        {notification && notification.length > 0 && (
                            <ReactPaginate
                                className='pagination mt-4'
                                breakLabel="..."
                                nextLabel={`${t('next')} >`}
                                previousLabel={`< ${t('Previous')} `}
                                renderOnZeroPageCount={null}
                                onPageChange={handlePageClick}
                                pageCount={Math.ceil(totalPage.total / totalPage.page_limit)}
                            />
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Notification;